export enum WalletTransactionStatus {
  All = 0,
  Approved = 1,
  Cancelled = 2,
  Failed = 3,
  PendingApproval = 4,
  Declined = 5,
  PendingFPXServerResponse = 6,
  FPXSuccessful = 7,
}
